<template>
  <div class="ml-2 md:ml-2 flex items-center gap-2 mt-2">
    <p
      class="w-2 h-2 rounded-full"
      :class="{ 'bg-lime-100': !isLimitExceeded, 'bg-ruby-red-100': isLimitExceeded }">
    </p>
    <span
      v-if="maxCount"
      :class="isLimitExceeded ? 'text-red-500' : 'text-gray-500'">
      {{ count }} / {{ maxCount }} {{ unitLabel }}
    </span>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

interface Props {
  text: string
  mode?: 'characters' | 'words'
  maxCount?: number
}

const props = defineProps<Props>()

const mode = computed(() => props.mode ?? 'characters')

const count = computed(() => {
  if (mode.value === 'words') {
    return props.text.trim().split(/\s+/).filter(Boolean).length
  }
  return props.text.length
})

const isLimitExceeded = computed(() => {
  return props.maxCount ? count.value > props.maxCount : false
})

const unitLabel = computed(() => (mode.value === 'words' ? 'words' : 'characters'))
</script>
